import { createIcon } from './icon-utils';

export const SmallTemplateIcon = createIcon({
  path: 'M8.82812 5.99967V2.33301H13.6615V5.99967H8.82812ZM2.32812 8.33301V2.33301H7.16146V8.33301H2.32812ZM8.82812 13.6663V7.66634H13.6615V13.6663H8.82812ZM2.32812 13.6663V9.99967H7.16146V13.6663H2.32812ZM3.32812 7.33301H6.16146V3.33301H3.32812V7.33301ZM9.82812 12.6663H12.6615V8.66634H9.82812V12.6663ZM9.82812 4.99967H12.6615V3.33301H9.82812V4.99967ZM3.32812 12.6663H6.16146V10.9997H3.32812V12.6663Z',
  style: { height: 16, width: 16 },
  viewBox: '0 0 16 16',
});
